import { render, staticRenderFns } from "./CreateCollectionDetails.vue?vue&type=template&id=1f19103d&scoped=true&"
import script from "./CreateCollectionDetails.vue?vue&type=script&lang=js&"
export * from "./CreateCollectionDetails.vue?vue&type=script&lang=js&"
import style0 from "./CreateCollectionDetails.vue?vue&type=style&index=0&id=1f19103d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f19103d",
  null
  
)

export default component.exports